import { useEffect, useState, useRef } from "react";
import {
  Avatar,
  Box,
  Button,
  IconButton,
  List,
  ListItemButton,
  Stack,
  TextField,
  ThemeProvider,
  Typography,
  createTheme,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ListItem,
  ListItemText,
  Checkbox,
  Badge,
  Tooltip,
  Grid,
  useMediaQuery,
  InputAdornment,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import SendIcon from "@mui/icons-material/Send";
import BlockIcon from "@mui/icons-material/Block";
import ChatSection from "./ChatSection";
import axios from "axios";
import {
  CHATSECRETKEY,
  decryptMessages,
  showToast,
  tabsStyle,
  WEBSERVICE,
} from "../../CoreDataService";
import { useChat } from "../../Services/ChatService";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

import CryptoJS from "crypto-js";
import { useSelector } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import SettingsIcon from "@mui/icons-material/Settings";
import SmsFailedIcon from "@mui/icons-material/SmsFailed";
import { useTheme } from "@mui/material/styles";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index}>
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#121212",
      paper: "#1e1e1e",
    },
  },
});

const ChatApp = () => {
  const { btncolor } = useSelector((state) => state);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const themecolor = localStorage.getItem("theme");

  const [parentTab, setParentTab] = useState(0); // 0: Direct Chat, 1: Group Chat
  const [childTab, setChildTab] = useState(0); // 0: Chat with Broker, 1: Chat with Trader
  // const [brokerMessages, setBrokerMessages] = useState('');
  const [brokerDetails, setBrokerDetails] = useState(null);
  const [isBlockedMeBroker, setIsBlockedMeBroker] = useState(false);
  const [IsBlockedMe, setIsBlockedMe] = useState("");
  const [isBlockedUser, setIsBlockedUser] = useState("");

  const [brokerUuid, setBrokerUuid] = useState(null);
  const [brokerPreviousMessages, setBrokerPreviousMessages] = useState([]);
  const [brokerFullMessage, setBrokerFullMessage] = useState("");
  const [previousUserHistory, setPreviousUserHistory] = useState([]);
  const [traderPreviousMessages, setTraderPreviousMessages] = useState([]);
  const [selectedList, setSelectedList] = useState();
  const [traderFullMessage, setTraderFullMessage] = useState("");
  const [chatSectionStatus, setChatSectionStatus] = useState(false);
  const [chatTraderName, setChatTraderName] = useState("");
  const [chatTraderUserName, setChatTraderUserName] = useState("");
  const [chatTraderUuid, setChatTraderUuid] = useState("");
  const [chatTraderEmailId, setChatTraderEmailId] = useState("");
  const [chatTraderOnlineStatus, setChatTraderOnlineStatus] = useState(false);
  const [traderSearchInput, setTraderSearchInput] = useState("");
  const [searchTraderStatus, setSearchTraderStatus] = useState(false);
  const [searchactive, setSearch] = useState(false);

  const [findedTradersFromSearch, setFindedTradersFromSearch] = useState([]);
  const [loadStatus, setLoadStatus] = useState(false);
  const [allGroupListRest, setAllGroupListRest] = useState([]);

  const [groupFullMessage, setGroupFullMessage] = useState("");
  const [chatGroupName, setChatGroupName] = useState("");
  const [chatGroupIdSelected, setChatGroupIdSelected] = useState("");
  const [groupIcon, setGroupIcon] = useState("");

  const [groupPreviousMessages, setGroupPreviousMessages] = useState([]);
  const [selectedGroupMessageList, setSelectedGroupMessageList] = useState([]);
  const [selectedGroupName, setSelectedGroupName] = useState("");
  const [selectedGroupDescription, setSelectedGroupDescription] = useState("");
  const [selectedGroupChatId, setSelectedGroupChatId] = useState("");
  const [creatorId, setCreatorId] = useState("");
  const [myAdminStatus, setMyAdminStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userUuid, setUserUuid] = useState(localStorage.getItem("uuid"));
  const [groupIconSelected, setGroupIconSelected] = useState(null);

  const [groupName, setGroupName] = useState("");
  const [traderSearchGroup, setTraderSearchGroup] = useState("");
  const [selectedTraders, setSelectedTraders] = useState([]);
  const [groupCreateModal, setGroupCreateModal] = useState(false);
  const { userInfo } = useSelector((state) => state);
  const [groupCreateUserList, setGroupCreateUserList] = useState([]);
  const [groupInfoModal, setGroupInfoModal] = useState(false);
  const [addUserStatus, setAddUserStatus] = useState(false);
  const [openRemoveModal, setOpenRemoveModal] = useState(false);
  const [removeNotification, setRemoveNotification] = useState("");
  const [removeUserName, setRemoveUserName] = useState("");

  const [openAdminModal, setOpenAdminModal] = useState(false);
  const [adminRemoveNotification, setAdminRemoveNotification] = useState("");
  const [actionableUseruuid, setActionableUseruuid] = useState("");
  const [groupChatSectionStatus, setGroupChatSectionStatus] = useState(false);
  const messagesEndRef = useRef(null);

  const [typingUserUuid, setTypingUserUuid] = useState("");
  const [typingUserPlaceStatus, setTypingUserPlaceStatus] = useState(false);
  const [typingUsersName, setTypingUsersName] = useState("");
  const typingTimeoutRef = useRef(null);

  const accessToken = localStorage.getItem("access_token");
  const BROKERID = localStorage.getItem("BROKERID");

  const {
    message,
    onlineUsers,
    onlineBroker,
    p2pmessage,
    p2pmessageCustomer,
    p2pmessageCustomerAppeal,
    makeUserOnline,
    sendMessageToUser,
    getMessageCount,
    groupMessageJoinRoom,
    getMessagesFromSocket,
    getTypingEvent,
    sendTypingSocket,
  } = useChat(); // Access state and methods

  const fileInputRef = useRef(null);

  const handleCloseInfo = () => (
    setGroupInfoModal(false), setRemoveUserName("")
  );

  const getPreviousBrokerChatList = async () => {
    const inputObj = {
      pageSize: 100,
      pageNo: 1,
      fromUserUuid: localStorage.getItem("uuid"),
      userType: "BROKER",
      brokerId: localStorage.getItem("BROKERID"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/getUserChats`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.chatUserList && response.data.chatUserList.length > 0) {
        const brokerInfo = response.data.chatUserList[0];
        setBrokerDetails(brokerInfo);
        setIsBlockedMeBroker(brokerInfo.userStatus);
      }
    } catch (error) {
      showToast("error", "Error fetching broker chat list:");
    }
  };
  // useEffect(() => {
  //   if (brokerDetails) getAllPreviousChatMessagesForBroker(brokerDetails?.uuid);
  // });

  const getBrokerUuid = async () => {
    const inputObj = {
      searchString: BROKERID,
      pageSize: 100,
      pageNo: 1,
      fromUserUuid: userUuid,
      userType: "BROKER",
      brokerId: "",
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/searchChatUser`,
        inputObj,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      if (response.data.chatUserList?.length > 0) {
        const uuid = response.data.chatUserList[0].uuid;
        setBrokerUuid(uuid);
        getAllPreviousChatMessagesForBroker(uuid);
        createBrokerChat(uuid);
      }
    } catch (error) {
      console.error("Error fetching broker UUID:", error);
    }
  };

  const getAllPreviousChatMessagesForBroker = async (uuid) => {
    const inputObj = {
      pageSize: 100,
      pageNo: 1,
      fromUserUuid: userUuid,
      toUserUuid: uuid,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/getUserChatMessages`,
        inputObj,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      let messages = response.data.chatMessageList || [];
      messages = messages.reverse();
      setBrokerPreviousMessages(messages);
      console.log("Previous messages:", messages);
    } catch (error) {
      console.error("Error fetching previous chat messages:", error);
    }
  };

  const createBrokerChat = async (uuid) => {
    const inputObj = {
      fromUserUuid: userUuid,
      toUserUuid: uuid,
      userType: "BROKER",
    };

    try {
      await axios.post(`${WEBSERVICE}user/createUserChat`, inputObj, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `BEARER ${accessToken}`,
        },
      });
    } catch (error) {
      console.error("Error creating broker chat:", error);
    }
  };

  const getPreviousUserChatList = async () => {
    const inputObj = {
      pageSize: 100,
      pageNo: 1,
      fromUserUuid: localStorage.getItem("uuid"),
      userType: "TRADER",
      brokerId: localStorage.getItem("BROKERID"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/getUserChats`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const chatUserList = response.data.chatUserList || [];
      setPreviousUserHistory(chatUserList);

      if (chatUserList && chatUserList.length > 0) {
        modifyListForOnlineShow(chatUserList);
      }
    } catch (error) {
      console.error("Error fetching previous chat list:", error);
    }
  };
  const isBrokerOneline = () =>
    onlineBroker.some(
      (user) => decryptMessages(user.userId) === brokerDetails?.uuid
    );

  const modifyListForOnlineShow = (chatList) => {
    if (!chatList || chatList.length === 0) {
      setPreviousUserHistory([]);
      return;
    }

    try {
      const updatedList = chatList.map((chatUser) => {
        const isOnline = onlineUsers.some(
          (user) => user.userId === chatUser.uuid
        );
        return {
          ...chatUser,
          isOnline,
        };
      });

      // Sort: Online users first
      const sortedList = updatedList.sort((a, b) => b.isOnline - a.isOnline);

      setPreviousUserHistory(sortedList);
    } catch (error) {
      console.error("Error in modifyListForOnlineShow:", error);
    }
  };

  console.log("online users", onlineBroker);

  const storeTraderDetails = (data, list) => {
    setSelectedList(list);

    setTraderFullMessage("");
    setChatSectionStatus(true);

    setChatTraderName(data.name);
    setChatTraderUserName(data.name);
    setChatTraderUuid(data.uuid);
    setChatTraderEmailId(data.emailId);
    setChatTraderOnlineStatus(data.isOnline);

    // Assuming default values to simulate Angular: isBlockedUser = 1, isBlockedMe = 1
    const isBlockedUser = data.userStatus;
    const isBlockedMeLocal = data.myStatus;
    setIsBlockedMe(data.myStatus);
    setIsBlockedUser(data.userStatus);

    if (isBlockedMeLocal === 0) {
      showToast("error", "User has blocked you"); // You’ll need to define this function
    }

    if (isBlockedMeLocal === 0) {
      setTraderFullMessage("You have blocked the user");
    }

    createTraderChat(data.uuid);
    getTraderPreviousMessages(data.uuid);
  };

  const storeSearchedTraderDetails = (data, list) => {
    setSelectedList(list);

    setTraderFullMessage("");
    setChatSectionStatus(true);

    setChatTraderName(data.name);
    setChatTraderUserName(data.name);
    setChatTraderUuid(data.uuid);
    setChatTraderEmailId(data.emailId);
    setChatTraderOnlineStatus(data.isOnline);

    // Assuming default values to simulate Angular: isBlockedUser = 1, isBlockedMe = 1
    const isBlockedUser = 1;
    const isBlockedMeLocal = 1;
    setIsBlockedMe(1);
    setIsBlockedUser(1);

    if (isBlockedMeLocal === 0) {
      showToast("error", "User has blocked you"); // You’ll need to define this function
    }

    if (isBlockedMeLocal === 0) {
      setTraderFullMessage("You have blocked the user");
    }

    createTraderChat(data.uuid);
    getTraderPreviousMessages(data.uuid);
  };

  const createTraderChat = async (uuid) => {
    const inputObj = {
      fromUserUuid: localStorage.getItem("uuid"),
      toUserUuid: uuid,
      userType: "TRADER",
    };

    try {
      await axios.post(
        `${WEBSERVICE}user/createUserChat`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      // No further action taken as per Angular version
    } catch (error) {
      console.error("Failed to create chat:", error);
    }
  };

  const getTraderPreviousMessages = async (uuid) => {
    const inputObj = {
      pageSize: 100,
      pageNo: 1,
      fromUserUuid: localStorage.getItem("uuid"),
      toUserUuid: uuid,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/getUserChatMessages`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      let messages = response.data.chatMessageList;
      if (!messages || messages === "") {
        messages = [];
      }

      setTraderPreviousMessages(messages.reverse());
    } catch (error) {
      console.error("Failed to fetch trader previous messages:", error);
    }
  };

  const searchTraders = async (value) => {
    setSearch(true);
    setTraderSearchInput(value); // assuming traderSearchInput is state-bound input

    if (value === "") {
      setSearchTraderStatus(false);
    } else {
      const inputObj = {
        searchString: value,
        pageSize: 100,
        pageNo: 1,
        fromUserUuid: localStorage.getItem("uuid"),
        userType: "TRADER",
        brokerId: localStorage.getItem("BROKERID"),
      };

      try {
        const response = await axios.post(
          `${WEBSERVICE}user/searchChatUser`,
          JSON.stringify(inputObj),
          {
            headers: {
              "Content-Type": "application/json",
              authorization: "BEARER " + localStorage.getItem("access_token"),
            },
          }
        );

        const resultList = response.data.chatUserList || [];
        setFindedTradersFromSearch(resultList);

        if (resultList && resultList.length > 0) {
          setSearchTraderStatus(true);
          modifySearchListForOnlineShow(resultList); // Assuming this function updates online status
        }
      } catch (error) {
        console.error("Error searching traders:", error);
      }
    }
  };

  const modifySearchListForOnlineShow = (resultList) => {
    if (!resultList || resultList.length === 0) return;

    try {
      const updatedList = resultList.map((trader) => {
        const isOnline = onlineUsers.some(
          (user) => user.userId === trader.uuid
        );
        return {
          ...trader,
          isOnline,
        };
      });

      console.log("modified search", updatedList);
      setFindedTradersFromSearch(updatedList);
    } catch (error) {
      console.log("in catch block", error);
    }
  };

  const selectSearchedTrader = (newData) => {
    setSearchTraderStatus(false);

    // Prepend newData to the previousUserHistory
    setPreviousUserHistory((prev) => [newData, ...prev]);

    storeSearchedTraderDetails(newData, 0);
  };

  useEffect(() => {
    getBrokerUuid();
    getPreviousBrokerChatList();
    getPreviousUserChatList();
    getAllGroups();
  }, []);
  // useEffect(() => {
  //   if (message) {
  //     handleNewBrokerMessage(message);
  //   }
  // }, [message, getMessagesFromSocket]);
  console.log("broker msg", message);

  useEffect(() => {
    if (message) {
      // Add a debounce or duplicate check
      const isDuplicate = brokerPreviousMessages.some(
        (msg) =>
          msg.id === message.id ||
          (msg.message === message.message && msg.time === message.time)
      );

      if (!isDuplicate) {
        handleNewBrokerMessage(message);
      }
    }
  }, [message, getMessagesFromSocket]);
  useEffect(() => {
    if (messagesEndRef.current) {
      console.log("test scroll");

      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [brokerPreviousMessages]);
  // traderPreviousMessages,
  // groupPreviousMessages,
  // message,

  // Function to handle new incoming message
  const handleNewBrokerMessage = (val) => {
    //   const decryptedMessage = decryptMessage(val.message);
    const addedMessage = {
      id: Date.now(),
      message: val.message,
      date: val.date,
      time: val.time,
      fromuser: val.user,
      matched: "false",
    };

    setBrokerPreviousMessages((prevMessages) => [
      ...prevMessages,
      addedMessage,
    ]);
    setTraderPreviousMessages((prevMessages) => [
      ...prevMessages,
      addedMessage,
    ]);
  };

  const sendMessageToBroker = () => {
    if (!brokerFullMessage || brokerFullMessage.trim() === "") {
      showToast("error", "cannot leave blank");
      return;
    }

    const dateToday = moment(new Date()).format("DD MMMM YYYY");

    // Encrypt message: Text ➜ AES ➜ Base64 ➜ Hex
    const b64 = CryptoJS.AES.encrypt(
      brokerFullMessage,
      CHATSECRETKEY
    ).toString();
    const e64 = CryptoJS.enc.Base64.parse(b64);
    const eHex = e64.toString(CryptoJS.enc.Hex);

    const messageData = {
      date: dateToday,
      user: userUuid,
      id: 1,
      message: eHex,
      status: 1,
      time: new Date().toLocaleTimeString(),
      touser: brokerUuid,
    };

    const addedMessage = {
      message: eHex,
      date: dateToday,
      time: new Date().toLocaleTimeString(),
      fromuser: userUuid,
      matched: "false",
    };

    // Send message via socket or chat service
    sendMessageToUser("sendmessage", messageData);

    // Update local message state
    setBrokerPreviousMessages((prev) => [...prev, addedMessage]);

    // Clear input
    setBrokerFullMessage("");

    console.log("prev", brokerPreviousMessages);
  };

  const sendMessageToTrader = () => {
    if (!traderFullMessage || traderFullMessage.trim() === "") {
      showToast("error", "cannot leave blank");
      return;
    }

    const dateToday = moment(new Date()).format("DD MMMM YYYY");

    // Encrypt message: Text ➜ AES ➜ Base64 ➜ Hex
    const b64 = CryptoJS.AES.encrypt(
      traderFullMessage,
      CHATSECRETKEY
    ).toString();
    const e64 = CryptoJS.enc.Base64.parse(b64);
    const eHex = e64.toString(CryptoJS.enc.Hex);

    const messageData = {
      date: dateToday,
      user: userUuid,
      id: 1,
      message: eHex,
      status: 1,
      time: new Date().toLocaleTimeString(),
      touser: chatTraderUuid,
    };

    const addedMessage = {
      message: eHex,
      date: dateToday,
      time: new Date().toLocaleTimeString(),
      fromuser: userUuid,
      matched: "false",
    };

    // Send message via socket or chat service
    sendMessageToUser("sendmessage", messageData);

    // Update local message state
    setTraderPreviousMessages((prev) => [...prev, addedMessage]);

    // Clear input
    setTraderFullMessage("");

    console.log("prev", traderPreviousMessages);
  };

  const blockUser = async () => {
    const inputObj = {
      fromUserUuid: userUuid,
      toUserUuid: chatTraderUuid,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/blockUserChat`,
        inputObj,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      if (response.data.error.error_data === 0) {
        showToast("success", "Blocked successfully");
        setIsBlockedMe(0);
        setTraderFullMessage("You have blocked the user");
        getPreviousUserChatList();
      } else {
        showToast("error", response.data.error.error_msg);
      }
    } catch (error) {
      console.error("Error blocking user:", error);
      showToast("error", "Failed to block user");
    }
  };

  const unBlockUser = async () => {
    const inputObj = {
      fromUserUuid: userUuid,
      toUserUuid: chatTraderUuid,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/unblockUserChat`,
        inputObj,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      if (response.data.error.error_data === 0) {
        showToast("success", "Unblocked successfully");
        setIsBlockedMe(1);
        setTraderFullMessage("");
        getPreviousUserChatList();
      } else {
        showToast("error", response.data.error.error_msg);
      }
    } catch (error) {
      console.error("Error unblocking user:", error);
      showToast("error", "Failed to unblock user");
    }
  };

  const getAllGroups = async () => {
    setLoadStatus(true); // Equivalent to: this.loadStatus = true;

    const inputObj = {
      fromUserUuid: userUuid,
      userType: "trader",
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/getChatGroupByUser`,
        inputObj,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      setLoadStatus(false); // Equivalent to: this.loadStatus = false;

      if (response.data.error.error_data === 0) {
        const groupList = response.data.groupChats;

        setAllGroupListRest(groupList);
        if (selectedList) {
          const filterGroupData = groupList[selectedList];
          storeGroupDetails(filterGroupData, selectedList);
        }

        // Call getMessageCountByGroupId for each group
        groupList.forEach((group) => {
          getMessageCountByGroupId(group.groupChatId);
        });

        // Optional: Delayed message update logic (if needed)
        // setTimeout(() => {
        //     const groupId = 'd5ea0067-18d2-4f0f-8ac9-2556ecb26a85';
        //     const groupIndex = groupList.findIndex(g => g.groupChatId === groupId);
        //     if (groupIndex !== -1) {
        //         const updatedGroups = [...groupList];
        //         updatedGroups[groupIndex].unreadMessageCount += 1;
        //         setAllGroupListRest(updatedGroups);
        //     }
        // }, 8000);
      } else {
        showToast(
          "error",
          response.data.error.error_msg || "Failed to fetch groups"
        );
      }
    } catch (error) {
      setLoadStatus(false);
      console.error("Error fetching group chats:", error);
      showToast("error", "An error occurred while fetching groups");
    }
  };

  const getMessageCountByGroupId = (uuid) => {
    console.log("new message count called for groupId:", uuid);

    const messageCount$ = getMessageCount(uuid); // get observable from socket

    if (!messageCount$) return;

    const subscription = messageCount$.subscribe((val) => {
      console.log("full notification:", val);

      if (!val || !val.group) {
        console.log("Invalid message value:", val);
        return;
      }

      setAllGroupListRest((prevList) => {
        const newList = [...prevList];
        const index = newList.findIndex((x) => x.groupChatId === val.group);
        if (index !== -1) {
          const currentCount = newList[index].unreadMessageCount || 0;
          newList[index] = {
            ...newList[index],
            unreadMessageCount: currentCount + 1,
          };
        }
        return newList;
      });
    });

    // Optional: Store or manage subscriptions to clean them up later if needed
  };

  const storeGroupDetails = (data, list) => {
    console.log("datassssss", data);

    setSelectedList(list); // useState setter

    setGroupFullMessage(""); // clear message thread
    setGroupChatSectionStatus(true); // open chat area
    setChatGroupName(data.groupChatName); // set group name
    setChatGroupIdSelected(data.groupChatId); // set group ID

    setGroupIcon(
      `https://userkycdoc.s3.us-west-1.amazonaws.com/chat_group_icons/${data.groupIcon}`
    );

    // Join the chat room
    groupMessageJoinRoom(data.groupChatId); // assuming this is exposed from context

    // Fetch messages
    getGroupPreviousMessages(data.groupChatId);
    getGroupMessagesFromSocket(data.groupChatId);
    // getTypingEventSocket();

    // Reset unread message count in group list
    setAllGroupListRest((prevList) =>
      prevList.map((group) =>
        group.groupChatId === data.groupChatId
          ? { ...group, unreadMessageCount: 0 }
          : group
      )
    );

    console.log("updated", list);
  };

  const getGroupMessagesFromSocket = (groupId) => {
    // Subscribe to messages
    getMessagesFromSocket(groupId).subscribe((val) => {
      if (!val?.message) return;

      const addedMessage = {
        date: val.date,
        sender: val.sender,
        id: val.id,
        message: val.message,
        status: val.status,
        time: val.time,
        group: val.group,
        socketId: val.socketId,
        chatType: 1,
        fromuser: val.sender,
        userUuid: val.sender,
      };

      console.log("New message received:", addedMessage);
      // update your message state here (e.g., using setMessages)
      setGroupPreviousMessages((prev) => [...prev, addedMessage]);
    });
  };

  const sendTypingEvent = () => {
    const typingData = {
      user: userUuid,
      group: chatGroupIdSelected,
    };

    console.log("test", typingData);

    sendTypingSocket("sendgroupmsgtyping", typingData);
  };

  const getTypingEventSocket = (groupId) => {
    getTypingEvent(chatGroupIdSelected).subscribe((val) => {
      console.log("valll", val);

      if (val.group === chatGroupIdSelected) {
        console.log("in group");

        const typingUuidlocal = val.user;

        const filteredData = selectedGroupMessageList.filter(
          (msg) => msg.userUuid === typingUuidlocal
        );

        if (filteredData.length > 0 && filteredData[0].userUuid !== userUuid) {
          console.log("in if");
          setTypingUserPlaceStatus(true);
          setTypingUsersName(filteredData[0].userName);

          // Clear previous timeout
          if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
          }

          // Set new timeout to hide "typing" after 3 seconds of inactivity
          typingTimeoutRef.current = setTimeout(() => {
            setTypingUserPlaceStatus(false);
          }, 3000);
        } else {
          setTypingUserPlaceStatus(false);
        }
      } else {
        console.log("not group", val.group);
        setTypingUserPlaceStatus(false);
      }
    });
  };

  const getGroupPreviousMessages = async (groupId) => {
    setLoading(true);

    const inputObj = {
      groupId,
      pageSize: 100,
      fromUserUuid: userUuid,
      pageNo: 1,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/getChatGroupMessages`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const { groupChatUserList, groupChat, chatMessageList } = response.data;

      setSelectedGroupMessageList(groupChatUserList);
      setSelectedGroupName(groupChat.groupChatName);
      setSelectedGroupDescription(groupChat.groupDescription);
      setSelectedGroupChatId(groupChat.groupChatId);
      setCreatorId(groupChat.createdBy);

      const processedMessages = chatMessageList
        .map((msg) => ({
          ...msg,
          group: groupChat.groupChatId,
        }))
        .reverse();

      console.log("processedMessages", processedMessages);

      setGroupPreviousMessages(processedMessages);

      // Determine if current user is admin
      const myUserData = groupChatUserList.find((u) => u.userUuid === userUuid);
      setMyAdminStatus(myUserData?.isAdmin === 1);

      // Scroll after delay
      setTimeout(() => {
        // if (scrollToBottom) scrollToBottom();
      }, 250);
    } catch (error) {
      console.error("Failed to fetch previous messages:", error);
    } finally {
      setLoading(false);
    }
  };

  const sendMessageToGroup = () => {
    createTraderChat(); // optional setup logic

    if (!groupFullMessage || groupFullMessage.trim() === "") {
      showToast("error", "Cannot leave blank");
      return;
    }

    const dateToday = moment(new Date()).format("DD MMMM YYYY");

    // Encrypt the message
    const b64 = CryptoJS.AES.encrypt(
      groupFullMessage,
      CHATSECRETKEY
    ).toString();
    const e64 = CryptoJS.enc.Base64.parse(b64);
    const encryptData = e64.toString(CryptoJS.enc.Hex);

    const messageData = {
      date: dateToday,
      sender: userUuid,
      id: 1,
      message: encryptData,
      status: 1,
      time: new Date().toLocaleTimeString(),
      group: chatGroupIdSelected,
    };

    sendMessageToUser("sendgroupmessage", messageData);

    // Optionally update your local message state if needed
    // setGroupPreviousMessages(prev => [...prev, messageData]);

    setGroupFullMessage("");
  };

  //       const handleCheckboxChange = (event, trader) => {
  //     if (event.target.checked) {
  //       setSelectedTraders(prev => [...prev, trader]);
  //     } else {
  //       setSelectedTraders(prev => prev.filter(t => t !== trader));
  //     }
  //   };

  const handleConfirm = () => {
    if (groupName && selectedTraders.length > 0) {
      //   onSubmit({ groupName, selectedTraders });
      //   onClose(); // Close modal after submit
    }
  };

  const onSaveUsernameChanged = (e, val) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      const alreadyExists = groupCreateUserList.some(
        (user) => user.userUuid === val.uuid
      );
      if (!alreadyExists) {
        const newUser = {
          userUuid: val.uuid,
          userType: "Trader",
          userName: val.name,
        };
        setGroupCreateUserList((prev) => [...prev, newUser]);
      }
    } else {
      setGroupCreateUserList((prev) =>
        prev.filter((user) => user.userUuid !== val.uuid)
      );
    }

    // Optional: log current state
    console.log("latest", groupCreateUserList);
  };

  const handleCreateGroupSubmit = async () => {
    const { firstName, middleName, lastName } = userInfo.userResult || {};

    const fullName = [firstName, middleName, lastName]
      .filter((name) => name && name.trim() !== "") // remove null, undefined, or empty
      .join(" ");
    const currentUser = {
      userUuid: userUuid,
      userType: "Trader",
      userName: fullName,
    };

    // Add the creator to the beginning of the user list
    const updatedUserList = [currentUser, ...groupCreateUserList];

    const finalGroupCreatePayload = {
      groupChat: {
        groupChatName: groupName,
        creatorId: userUuid,
        creatorName: fullName,
        userType: "trader",
        groupUsers: updatedUserList,
      },
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/createChatGroup`,
        JSON.stringify(finalGroupCreatePayload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data === 0) {
        setGroupCreateModal(false);
        setSearch(false);
        showToast("success", response.data.error.error_msg);
        setGroupName("");
        setTraderSearchGroup("");
        setSelectedTraders([]);
        getAllGroups(); // Refetch groups
      } else {
        showToast("error", response.data.error.error_msg);
      }
    } catch (error) {
      console.error("Group creation failed:", error);
      showToast("error", "Something went wrong. Please try again.");
    }
  };

  const handleFileInput = async (event) => {
    const { firstName, middleName, lastName } = userInfo.userResult || {};

    const fullName = [firstName, middleName, lastName]
      .filter((name) => name && name.trim() !== "") // remove null, undefined, or empty
      .join(" ");
    const file = event.target.files[0];
    if (!file) return;
    if (file) {
      const imageURL = URL.createObjectURL(file);
      setGroupIconSelected(imageURL); // update preview
    }

    const fd = new FormData();
    fd.append("groupId", chatGroupIdSelected);
    fd.append("creatorId", userUuid);
    fd.append("userType", "Trdaer");
    fd.append("creatorName", fullName);
    fd.append("groupIcon", file);

    try {
      const result = await axios.post(
        `${WEBSERVICE}user/updateChatGroupIcon`,
        fd,
        {
          headers: {
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (result.data.error.error_data !== 0) {
        showToast("error", result.data.error.error_msg);
      } else {
        getAllGroups();
        getGroupPreviousMessages(chatGroupIdSelected);
        showToast("success", "Icon updated successfully!");
        getAllGroupsAndSelectByGroupId();
      }
    } catch (error) {
      showToast("error", "Some error occurred.");
    }
  };

  const getAllGroupsAndSelectByGroupId = () => {
    setLoadStatus(true);

    const inputObj = {
      fromUserUuid: userUuid,
      userType: "trader",
    };

    axios
      .post(`${WEBSERVICE}user/getChatGroupByUser`, JSON.stringify(inputObj), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `BEARER ${accessToken}`,
        },
      })
      .then((response) => {
        const { data } = response;
        if (data.error.error_data === 0) {
          setLoadStatus(false);
          setAllGroupListRest(data.groupChats);

          const filteredGroup = data.groupChats.find(
            (group) => group.groupChatId === chatGroupIdSelected
          );

          console.log("popoo", filteredGroup);

          if (filteredGroup) {
            storeGroupDetails(filteredGroup, 0);
          }
        } else {
          console.error("API returned an error:", data.error);
        }
      })
      .catch((error) => {
        console.error("API error", error);
        setLoadStatus(false);
      });
  };

  const addUserInGroup = async () => {
    const { firstName, middleName, lastName } = userInfo.userResult || {};

    const fullName = [firstName, middleName, lastName]
      .filter((name) => name && name.trim() !== "") // remove null, undefined, or empty
      .join(" ");

    if (groupCreateUserList.length > 0) {
      const finalGroupCreatePayload = {
        groupChat: {
          groupChatId: chatGroupIdSelected,
          userUuid: userUuid,
          creatorName: fullName,
          userType: "trader",
          groupUsers: groupCreateUserList,
        },
      };

      console.log("final", finalGroupCreatePayload);

      try {
        const response = await axios.post(
          `${WEBSERVICE}user/addChatGroupUser`,
          JSON.stringify(finalGroupCreatePayload),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `BEARER ${accessToken}`,
            },
          }
        );

        if (response.data.error.error_data === 0) {
          showToast("success", response.data.error.error_msg);
          getAllGroups();
          getGroupPreviousMessages(chatGroupIdSelected);
          setAddUserStatus(false);
        } else {
          showToast("error", response.data.error.error_msg);
        }
      } catch (error) {
        console.error("API Error:", error);
        showToast("error", "An unexpected error occurred");
      }
    } else {
      showToast("error", "Please add Users first");
    }
  };

  const openRemoveNotificationModal = async (uuid) => {
    setActionableUseruuid(uuid);
    setOpenRemoveModal(true);
  };
  const openAdminRemoveNotificationModal = async (uuid) => {
    setActionableUseruuid(uuid);
    setOpenAdminModal(true);
  };

  const upgradeToAdmin = async (uuid) => {
    const payload = {
      groupChat: {
        groupChatId: chatGroupIdSelected,
        creatorId: userUuid,
        userUuid: uuid,
        userType: "TRADER",
      },
    };

    console.log("upGradeUserGroupCreatePayload", payload);

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/addChatGroupAdminUser`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error?.error_data === 0) {
        showToast("success", response.data.error.error_msg);
        window.location.reload(); // optional: refresh the group/user list
      } else {
        showToast(
          "error",
          response.data.error?.error_msg || "Something went wrong"
        );
      }
    } catch (error) {
      console.error("Error upgrading user:", error);
      showToast("error", "Failed to upgrade user to admin");
    }
  };

  const downgradeToAdmin = async () => {
    const payload = {
      groupChat: {
        groupChatId: chatGroupIdSelected,
        creatorId: userUuid,
        userUuid: actionableUseruuid,
        userType: "TRADER",
        notification: adminRemoveNotification,
      },
    };

    console.log("downGradeUserGroupCreatePayload", payload);

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/removeChatGroupAdminUser`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error?.error_data === 0) {
        showToast("success", response.data.error.error_msg);
        getAllGroups();
        getGroupPreviousMessages(chatGroupIdSelected);
        setOpenAdminModal(false);
        setAdminRemoveNotification("");
      } else {
        showToast(
          "error",
          response.data.error?.error_msg || "Failed to remove user"
        );
      }
    } catch (error) {
      showToast("error", "Error removing user from group:");
      showToast("error", "Error removing user from group");
    }
  };

  const handleRemoveUserFromGroup = async () => {
    const { firstName, middleName, lastName } = userInfo.userResult || {};

    const fullName = [firstName, middleName, lastName]
      .filter((name) => name && name.trim() !== "") // remove null, undefined, or empty
      .join(" ");
    const payload = {
      groupChat: {
        groupChatId: chatGroupIdSelected,
        creatorId: userUuid,
        userUuid: actionableUseruuid,
        userType: "trader",
        notification: `${fullName} removed ${removeUserName} Reason : ${removeNotification}`,
      },
    };

    // const demoString= 'Raja remove Arif Reason : No need this user'

    console.log("removeUserGroupCreatePayload", payload);

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/removeChatGroupUser`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error?.error_data === 0) {
        showToast("success", response.data.error.error_msg);
        getAllGroups();
        getGroupPreviousMessages(chatGroupIdSelected);
        setOpenRemoveModal(false);
        setRemoveNotification("");
      } else {
        showToast(
          "error",
          response.data.error?.error_msg || "Failed to remove user"
        );
      }

      // if (typeof onCloseModal === 'function') {
      //   onCloseModal(); // Close the modal if callback provided
      // }
    } catch (error) {
      showToast("error", "Error removing user from group:");
      showToast("error", "Error removing user from group");
    }
  };

  console.log("selectedList", selectedList, chatGroupIdSelected);

  const changeGroupName = async () => {
    const { firstName, middleName, lastName } = userInfo.userResult || {};

    const fullName = [firstName, middleName, lastName]
      .filter((name) => name && name.trim() !== "") // remove null, undefined, or empty
      .join(" ");
    const payload = {
      groupChat: {
        groupChatId: chatGroupIdSelected,
        creatorId: userUuid,
        creatorName: fullName,
        userType: "trader",
        groupChatName: selectedGroupName,
      },
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/updateChatGroupName`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error?.error_data === 0) {
        showToast("success", response.data.error.error_msg);
        getAllGroups();
        getGroupPreviousMessages(chatGroupIdSelected);
        getAllGroupsAndSelectByGroupId();
        // const filteredGroup = allGroupListRest.filter(
        //   (vals) => vals.groupChatId === chatGroupIdSelected
        // );
        // console.log("Filtered Group:", filteredGroup);

        // storeGroupDetails(filteredGroup[0], 0);
      } else {
        showToast("error", response.data.error?.error_msg || "Update failed");
      }
    } catch (err) {
      console.error("Error changing group name:", err);
      showToast("error", "Error updating group name");
    }
  };

  const changeGroupDescription = async () => {
    const { firstName, middleName, lastName } = userInfo.userResult || {};

    const fullName = [firstName, middleName, lastName]
      .filter((name) => name && name.trim() !== "") // remove null, undefined, or empty
      .join(" ");

    const payload = {
      groupChat: {
        groupChatId: chatGroupIdSelected,
        creatorId: userUuid,
        creatorName: fullName,
        userType: "trader",
        groupDescription: selectedGroupDescription,
      },
    };

    console.log("final", payload);

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/updateChatGroupDesc`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error?.error_data === 0) {
        showToast("success", response.data.error.error_msg);

        const filteredGroup = allGroupListRest.filter(
          (vals) => vals.groupChatId === chatGroupIdSelected
        );
        console.log("Filtered Group:", filteredGroup);

        storeGroupDetails(filteredGroup[0], 0);
      } else {
        showToast("error", response.data.error?.error_msg || "Update failed");
      }
    } catch (err) {
      console.error("Error changing group description:", err);
      showToast("error", "Error updating group description");
    }
  };

  // const getProfileImageLink = (uuid, selectedGroupMessageList) => {
  //     const defaultImage = 'https://bootdey.com/img/Content/avatar/avatar2.png';

  //     const filteredUser = selectedGroupMessageList.find(user => user.userUuid === uuid);
  //     console.log('filteredUser',filteredUser);

  //     if (!filteredUser) {
  //         return defaultImage;
  //     }

  //     const { userImage, userId } = filteredUser;

  //     if (!userImage) {
  //         console.log('defaultImage',defaultImage);

  //         return defaultImage;
  //     }
  //     else{
  //         console.log('defaultImage111',`https://userkycdoc.s3.us-west-1.amazonaws.com/user_id_${userId}/${userImage}`);

  //     return `https://userkycdoc.s3.us-west-1.amazonaws.com/user_id_${userId}/${userImage}`;

  //     }

  // };

  return (
    <Box sx={{ width: "100%" }}>
      {/* Parent Tabs */}
      <Tabs
        value={parentTab}
        onChange={(e, newValue) => {
          setParentTab(newValue);
          setChildTab(0); // Reset child tab when parent changes
        }}
        aria-label="Parent Chat Tabs"
        textColor="inherit"
        sx={tabsStyle(btncolor)}
      >
        <Tab label="Direct Chat" />
        <Tab label="Group Chat" />
      </Tabs>

      {/* Direct Chat */}
      <TabPanel value={parentTab} index={0}>
        {/* <Tabs
          value={childTab}
          onChange={(e, newValue) => setChildTab(newValue)}
          aria-label="Child Tabs for Direct Chat"
          textColor="inherit"
           sx={tabsStyle(btncolor)}
        >
          <Tab label="Chat with Broker" />
          <Tab label="Chat with Trader" />
        </Tabs> */}

        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            height: "80vh",
            bgcolor: "background.default",
            width: "80%",
            margin: "0 auto",
          }}
        >
          {/* Sidebar */}
          {/* {!isMobile && (
              <Box
                sx={{
                  width: 280,
                  bgcolor: "background.paper",
                  color: "white",
                  p: 2,
                }}
              >
                <List>
                  <ListItemButton sx={{ bgcolor: "grey.800", borderRadius: 2 }}>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Avatar sx={{ bgcolor: "primary.main" }}>
                        <PersonIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="body1">
                          {brokerDetails?.name}
                        </Typography>
                        <Typography variant="body2">
                          {brokerDetails?.userName}
                        </Typography>
                        <Typography
                          variant="caption"
                          color={isBrokerOneline ? "green" : "red"}
                        >
                          ● {isBrokerOneline ? "Online" : "Offline"}
                        </Typography>
                      </Box>
                    </Stack>
                  </ListItemButton>
                </List>
              </Box>
            )} */}

          {/* Main Chat Area */}
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",

              margin: "0 auto",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                p: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #333",
                bgcolor: "var(--body-color-less)",
              }}
            >
              <Stack direction="row" spacing={2} alignItems="center">
                <Avatar />
                <Box>
                  <Typography variant="body1">
                    Chat with {localStorage.getItem("exchange")}
                  </Typography>
                  <Typography
                    variant="caption"
                    color={isBrokerOneline ? "green" : "red"}
                  >
                    ● {isBrokerOneline ? "Online" : "Offline"}
                  </Typography>
                </Box>
              </Stack>
            </Box>

            {/* Messages */}
            <Box
              sx={{
                flexGrow: 1,
                p: 2,
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              {brokerPreviousMessages.map((msg) => (
                <Stack
                  key={msg.id}
                  direction="row"
                  justifyContent={
                    msg.fromuser === userUuid ? "flex-end" : "flex-start"
                  }
                  alignItems="flex-end"
                >
                  {msg.fromuser !== userUuid && <Avatar sx={{ mr: 1 }} />}
                  <Box
                    sx={{
                      maxWidth: isMobile ? "80%" : "60%",
                      // bgcolor:
                      //   msg.fromuser === userUuid ? "primary.main" : "grey.800",
                      bgcolor:
                        themecolor === "dark"
                          ? "primary.main"
                          : "rgb(222, 222, 222)",
                      color: "white",
                      p: 1.5,
                      borderRadius: 2,
                      borderTopLeftRadius: msg.fromuser === userUuid ? 12 : 0,
                      borderTopRightRadius: msg.fromuser === userUuid ? 0 : 12,
                    }}
                  >
                    <Typography variant="body2">
                      {decryptMessages(msg.message)}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ display: "block", textAlign: "right", mt: 0.5 }}
                      color="gray"
                    >
                      {msg.time} {msg.date}
                    </Typography>
                  </Box>
                  {msg.fromuser === userUuid && (
                    <Avatar sx={{ ml: 1, bgcolor: "secondary.main" }}>
                      Me
                    </Avatar>
                  )}
                </Stack>
              ))}
              <div ref={messagesEndRef} />
            </Box>

            {/* Input */}
            <Box
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                bgcolor: "var(--body-color-less)",
              }}
            >
              <TextField
                fullWidth
                placeholder="Ask me a question"
                variant="outlined"
                value={brokerFullMessage}
                onChange={(e) => setBrokerFullMessage(e.target.value)}
                size="small"
                sx={{
                  mr: 1,
                  input: { color: "text.primary" },
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault(); // Prevents new line if multiline is true
                    sendMessageToBroker();
                  }
                }}
              />
              <IconButton
                // color="primary"
                sx={{
                  bgcolor: btncolor,
                  flexShrink: 0,
                  "&:hover": {
                    bgcolor: btncolor, // Same background color on hover
                  },
                }}
                onClick={() => sendMessageToBroker()}
              >
                <SendIcon />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </TabPanel>

      {/* Group Chat */}
      <TabPanel value={parentTab} index={1}>
        {/* Render chat with trader content */}
        {/* <ThemeProvider theme={darkTheme}> */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            height: "100vh",
            bgcolor: "background.paper",
          }}
        >
          {/* Sidebar */}
          <Box
            sx={{
              width: { xs: "100%", md: 280 },
              bgcolor: "var(--body-color-less)",
              color: "white",
              p: 2,
            }}
          >
            <OutlinedButton
              fullWidth
              variant="outlined"
              size="small"
              onClick={() => setGroupCreateModal(true)}
              sx={{
                textTransform: "none",
              }}
            >
              Create Group
            </OutlinedButton>

            <Typography
              variant="subtitle2"
              gutterBottom
              mt={2}
              sx={{ color: "text.primary" }}
            >
              Group History
            </Typography>

            {allGroupListRest?.length !== 0 &&
              allGroupListRest.map((group, index) => (
                <List
                  key={group.id}
                  onClick={() => storeGroupDetails(group, index)}
                >
                  <ListItemButton
                    sx={{
                      bgcolor: "grey.800",
                      borderRadius: 2,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Avatar
                        src={`https://userkycdoc.s3.us-west-1.amazonaws.com/chat_group_icons/${group.groupIcon}`}
                        sx={{
                          bgcolor: "primary.main",
                          width: 40,
                          height: 40,
                        }}
                      />
                      <Box>
                        <Typography>{group.groupChatName}</Typography>
                      </Box>
                    </Stack>
                    {selectedList !== index && (
                      <Box>
                        <Typography>{group.unreadMessageCount}</Typography>
                      </Box>
                    )}
                  </ListItemButton>
                </List>
              ))}
          </Box>

          {/* Chat Section */}
          {groupChatSectionStatus ? (
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              {/* Header */}
              <Box
                sx={{
                  p: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #333",
                  bgcolor: "background.paper",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                <Stack direction="row" spacing={2} alignItems="center">
                  <Avatar
                    src={groupIcon}
                    sx={{ bgcolor: "primary.main", width: 40, height: 40 }}
                  />
                  <Typography>{chatGroupName}</Typography>
                </Stack>
                <OutlinedButton
                  variant="outlined"
                  startIcon={<SettingsIcon />}
                  onClick={() => setGroupInfoModal(true)}
                  size="small"
                >
                  Info
                </OutlinedButton>
              </Box>

              {/* Messages */}
              <Box
                sx={{
                  flexGrow: 1,
                  p: 2,
                  bgcolor: "background.default",
                  overflowY: "auto",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
                className="group-chat-container"
              >
                {groupPreviousMessages.map((msg) => (
                  <Stack
                    key={msg.id}
                    direction="row"
                    justifyContent={
                      msg.fromuser === userUuid &&
                      msg.chatType === 1 &&
                      msg.group === chatGroupIdSelected
                        ? "flex-end"
                        : "flex-start"
                    }
                    alignItems="flex-end"
                  >
                    {msg.fromuser !== userUuid &&
                      msg.chatType === 1 &&
                      msg.group === chatGroupIdSelected && (
                        <Avatar sx={{ mr: 1 }} />
                      )}

                    {msg.chatType === 1 ? (
                      <Box
                        sx={{
                          maxWidth: "75%",
                          bgcolor:
                            msg.fromuser === userUuid &&
                            msg.chatType === 1 &&
                            msg.group === chatGroupIdSelected
                              ? "primary.main"
                              : "grey.800",
                          color: "white",
                          p: 1.5,
                          borderRadius: 2,
                          borderTopLeftRadius:
                            msg.fromuser === userUuid ? 12 : 0,
                          borderTopRightRadius:
                            msg.fromuser === userUuid ? 0 : 12,
                        }}
                      >
                        <Typography variant="body2">
                          {decryptMessages(msg.message)}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            display: "block",
                            textAlign: "right",
                            mt: 0.5,
                          }}
                          color="gray"
                        >
                          {msg.time} {msg.date}
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          py: 1,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            px: 2,
                            py: 1,
                            bgcolor: "grey.700",
                            color: "white",
                            borderRadius: 1,
                            fontSize: "0.75rem",
                          }}
                        >
                          {msg.message} on {msg.date} at {msg.time}
                        </Typography>
                      </Box>
                    )}

                    {msg.fromuser === userUuid &&
                      msg.chatType === 1 &&
                      msg.group === chatGroupIdSelected && (
                        <Avatar sx={{ ml: 1, bgcolor: "secondary.main" }}>
                          Me
                        </Avatar>
                      )}
                  </Stack>
                ))}
                <div ref={messagesEndRef} />
              </Box>

              {/* Input */}
              <Box
                sx={{
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  bgcolor: "background.paper",
                  borderTop: "1px solid #333",
                }}
              >
                {typingUserPlaceStatus && (
                  <Typography variant="caption" sx={{ color: "gray", mb: 1 }}>
                    {`${typingUsersName} is typing...`}
                  </Typography>
                )}
                <Box sx={{ display: "flex" }}>
                  <TextField
                    fullWidth
                    placeholder="Enter text here..."
                    variant="outlined"
                    value={groupFullMessage}
                    onChange={(e) => {
                      setGroupFullMessage(e.target.value);
                      sendTypingEvent();
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault(); // prevent newline
                        sendMessageToGroup(); // call your function
                      }
                    }}
                    size="small"
                    sx={{ input: { color: "text.primary" }, mr: 1 }}
                  />
                  <IconButton
                    color="primary"
                    sx={{ bgcolor: "white" }}
                    onClick={sendMessageToGroup}
                  >
                    <SendIcon />
                  </IconButton>
                </Box>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                  p: 2,
                  bgcolor: "background.default",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Typography variant="h5" color="text.secondary">
                  <SmsFailedIcon /> Nothing selected
                </Typography>
                <Typography variant="h6" color="text.secondary">
                  Select or create a group to start a conversation.
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
        {/* </ThemeProvider> */}
      </TabPanel>

      <Dialog
        open={groupCreateModal}
        onClose={() => (setGroupCreateModal(false), setSearch(false))}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">Create Group</Typography>
            <IconButton
              onClick={() => (setGroupCreateModal(false), setSearch(false))}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent dividers>
          <Box mb={2} mt={2}>
            <TextField
              fullWidth
              label="Enter group name"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              placeholder="Enter a group name"
              variant="outlined"
            />
          </Box>

          <Box mb={2}>
            <TextField
              fullWidth
              label="Search Users"
              value={traderSearchGroup}
              onChange={(e) => setTraderSearchGroup(e.target.value)} // just update state here
              placeholder="Search for a trader using their email address"
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => searchTraders(traderSearchGroup)} // trigger search on icon click
                      edge="end"
                      sx={{ color: "#fff" }}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          {searchactive && (
            <Box
              sx={{
                height: 60,
                // overflowY: "auto",
                // backgroundColor: "background.default",
                // borderRadius: 1,
                // p: 2,
              }}
            >
              <List>
                {findedTradersFromSearch?.length !== 0 ? (
                  findedTradersFromSearch.map((trader, i) => (
                    <ListItem
                      key={i}
                      secondaryAction={
                        <Checkbox
                          edge="end"
                          onChange={(e) => onSaveUsernameChanged(e, trader)}
                          checked={groupCreateUserList.some(
                            (u) => u.userUuid === trader.uuid
                          )}
                        />
                      }
                      sx={{
                        backgroundColor: "#1a1f2e",
                        mb: 1,
                        borderRadius: 1,
                      }}
                    >
                      <Avatar
                        src="https://bootdey.com/img/Content/avatar/avatar2.png"
                        sx={{ mr: 2 }}
                      />
                      <ListItemText
                        primary={trader.name}
                        // secondary={trader.emailId}
                        primaryTypographyProps={{ color: "white" }}
                        secondaryTypographyProps={{
                          color: "gray",
                          fontSize: 12,
                        }}
                      />
                    </ListItem>
                  ))
                ) : (
                  <ListItem
                    sx={{
                      backgroundColor: "#1a1f2e",
                      mb: 1,
                      borderRadius: 1,
                      textAlign: "center",
                    }}
                  >
                    No user found with that email
                  </ListItem>
                )}
              </List>
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <ContainedButton
            variant="contained"
            fullWidth
            onClick={() => handleCreateGroupSubmit()}
            disabled={!groupName}
          >
            Confirm
          </ContainedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={groupInfoModal}
        onClose={() => handleCloseInfo()}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" textAlign="center" flexGrow={1}>
              {chatGroupName}
            </Typography>
            <IconButton onClick={() => handleCloseInfo()}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box display="flex" justifyContent="center" mb={2}>
            <Box position="relative">
              <Avatar
                src={groupIconSelected ? groupIconSelected : groupIcon}
                alt="Group Icon"
                sx={{ width: 100, height: 100 }}
              />
              {myAdminStatus && (
                <IconButton
                  sx={{ position: "absolute", bottom: 0, right: 0 }}
                  onClick={() => fileInputRef.current.click()}
                >
                  <EditIcon />
                </IconButton>
              )}
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleFileInput}
              />
            </Box>
          </Box>

          <Box display="flex" gap={1} mb={2}>
            <TextField
              fullWidth
              label="Group Name"
              value={selectedGroupName}
              onChange={(e) => setSelectedGroupName(e.target.value)}
            />
            {myAdminStatus && (
              <ContainedButton
                variant="contained"
                onClick={() => changeGroupName()}
              >
                Save
              </ContainedButton>
            )}
          </Box>

          <Box display="flex" gap={1} mb={2}>
            <TextField
              fullWidth
              label="Group Description"
              value={selectedGroupDescription}
              onChange={(e) => setSelectedGroupDescription(e.target.value)}
              multiline
              minRows={3}
            />
            {myAdminStatus && (
              <ContainedButton
                variant="contained"
                onClick={() => changeGroupDescription()}
              >
                Save
              </ContainedButton>
            )}
          </Box>

          {/* {myAdminStatus && (
            <Box display="flex" justifyContent="flex-end" mb={2}>
              <ContainedButton
                variant="contained"
                onClick={() => setAddUserStatus(true)}
              >
                Add User
              </ContainedButton>
            </Box>
          )} */}

          {myAdminStatus && (
            <Box mb={3}>
              <TextField
                fullWidth
                label="Search Users"
                value={traderSearchGroup}
                onChange={(e) => setTraderSearchGroup(e.target.value)} // just update state here
                placeholder="Search for a trader using their email address"
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => searchTraders(traderSearchGroup)} // trigger search on icon click
                        edge="end"
                        sx={{ color: "#fff" }}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {searchactive && (
                <Box sx={{ maxHeight: 300, overflowY: "auto", mt: 2 }}>
                  <List>
                    {findedTradersFromSearch?.length !== 0 ? (
                      findedTradersFromSearch.map((trader, i) => (
                        <ListItem
                          key={i}
                          secondaryAction={
                            <Checkbox
                              edge="end"
                              onChange={(e) => onSaveUsernameChanged(e, trader)}
                              checked={groupCreateUserList.some(
                                (u) => u.userUuid === trader.uuid
                              )}
                            />
                          }
                          sx={{ backgroundColor: "background.default" }}
                        >
                          <ListItemText
                            primary={trader.name}
                            // secondary={trader.emailId}
                          />
                        </ListItem>
                      ))
                    ) : (
                      <ListItem
                        sx={{
                          backgroundColor: "background.default",
                          mb: 1,
                          borderRadius: 1,
                          textAlign: "center",
                        }}
                      >
                        No user found with that email
                      </ListItem>
                    )}
                  </List>
                </Box>
              )}

              <Box display="flex" justifyContent="flex-end" mt={2} gap={2}>
                <ContainedButton
                  variant="contained"
                  onClick={() => addUserInGroup()}
                >
                  Add User
                </ContainedButton>
                <ContainedButton
                  variant="contained"
                  onClick={() => setAddUserStatus(false)}
                >
                  Cancel
                </ContainedButton>
              </Box>
            </Box>
          )}

          <Typography variant="subtitle1" align="center">
            User List ({selectedGroupMessageList.length})
          </Typography>

          <List>
            {selectedGroupMessageList.map((user, i) => (
              <ListItem
                key={i}
                sx={{ backgroundColor: "background.default" }}
                secondaryAction={
                  myAdminStatus &&
                  user.userUuid !== userUuid && (
                    <>
                      <Tooltip title="Remove user">
                        <IconButton
                          onClick={() => (
                            openRemoveNotificationModal(user.userUuid),
                            setRemoveUserName(user?.userName)
                          )}
                          color="error"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                      {user.isAdmin === 0 && (
                        <Tooltip title="Promote to Admin">
                          <IconButton
                            onClick={() => upgradeToAdmin(user.userUuid)}
                            color="success"
                          >
                            <ArrowUpwardIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                      {user.isAdmin === 1 && (
                        <Tooltip title="Demote Admin">
                          <IconButton
                            onClick={() =>
                              openAdminRemoveNotificationModal(user.userUuid)
                            }
                            color="warning"
                          >
                            <ArrowDownwardIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </>
                  )
                }
              >
                <ListItemText
                  primary={
                    <>
                      {user.userName}
                      {user.isAdmin === 1 && (
                        <span style={{ color: "lime", marginLeft: 8 }}>
                          Admin
                        </span>
                      )}
                      {user.userUuid === creatorId && (
                        <span style={{ color: "blue", marginLeft: 8 }}>
                          Creator
                        </span>
                      )}
                    </>
                  }
                  secondary={user.userEmail}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>

      {/* Remove User Modal */}
      <Dialog
        open={openRemoveModal}
        onClose={() => setOpenRemoveModal(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          <Grid container alignItems="center">
            <Grid size={3}></Grid>
            <Grid size={6} style={{ textAlign: "center" }}>
              Notification
            </Grid>
            <Grid size={3} style={{ textAlign: "right" }}>
              <IconButton
                onClick={() => setOpenRemoveModal(false)}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Enter a reason"
            variant="outlined"
            value={removeNotification}
            onChange={(e) => setRemoveNotification(e.target.value)}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <ContainedButton
            fullWidth
            variant="contained"
            disabled={!removeNotification?.trim()}
            onClick={() => handleRemoveUserFromGroup()}
          >
            Confirm
          </ContainedButton>
        </DialogActions>
      </Dialog>

      {/* Downgrade Admin Modal */}
      <Dialog
        open={openAdminModal}
        onClose={() => setOpenAdminModal(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          <Grid container alignItems="center">
            <Grid size={3}></Grid>
            <Grid size={6} style={{ textAlign: "center" }}>
              Notification
            </Grid>
            <Grid size={3} style={{ textAlign: "right" }}>
              <IconButton onClick={() => setOpenAdminModal(false)} size="small">
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Enter a reason"
            variant="outlined"
            value={adminRemoveNotification}
            onChange={(e) => setAdminRemoveNotification(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <ContainedButton
            fullWidth
            variant="contained"
            disabled={!adminRemoveNotification?.trim()}
            onClick={() => downgradeToAdmin()}
          >
            Confirm
          </ContainedButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ChatApp;
